<template>
    <div>
        <RateTableVue></RateTableVue>
    </div>
</template>

<script>
import RateTableVue from '@/components/Admin/Component/RateTable.vue';
export default {
    name: 'PadmawebRateView',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
    components:{
        RateTableVue
    }
};
</script>

<style lang="scss" scoped>

</style>